/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import DocsSearch from 'cio/components/docs-search';
import { InlineSupportPageArgs } from 'cio/components/inline-support';
import { Result } from 'cio/services/docs-search';

export default class SubjectPage extends Component<InlineSupportPageArgs> {
  @action
  handleSubjectInput(docsSearch: DocsSearch, value: string) {
    this.args.setFormValue('subject', value);

    docsSearch.handleInput(value);
  }

  @action
  trackDocsSuggestionsClick(result: Result) {
    this.args.trackEvent('inline_support_docs_suggestion_clicked', {
      title: result.title,
      url: result.href,
      page: 'subject',
    });
  }
}
